import * as z from 'zod';

export const NAME_LENGTH = 40;
export const SHORT_NAME_LENGTH = 10;

export const queueDetailsFormSchema = z.object({
  name: z.string().max(NAME_LENGTH).nonempty(),
  shortName: z.string().max(SHORT_NAME_LENGTH).nonempty(),
});

export type QueueDetailsFormSchema = z.infer<typeof queueDetailsFormSchema>;
